import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useTenant } from '../../hooks/useTenant'
import { updateTenant } from '../../services/api/updateTenant'
import { EditEntityPage } from '../EditEntityPage/EditEntityPage'
import { buildTenantEditRows } from './helpers/buildTenantEditRows'

export function TenantEditPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()
  const { tenant, isLoading, error } = useTenant(id ?? '')

  const rows = tenant ? buildTenantEditRows(tenant) : []

  async function handleSubmit(body: Record<string, unknown>) {
    await updateTenant(await getToken(), id ?? '', {
      ...body,
      tenantGroupId: tenant ? Number(tenant.tenantGroupId) : undefined,
    })
    navigate(`/tenants/${id}`)
  }

  return (
    <EditEntityPage
      title={tenant ? `Edit Tenant - ${tenant.code}` : 'Edit Tenant'}
      backTo={`/tenants/${id}`}
      loadingLabel="tenant"
      rows={rows}
      isLoading={isLoading}
      loadError={error}
      onSubmit={handleSubmit}
    />
  )
}
